import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';

export const useSearchParams = (): {
  search: ParsedUrlQuery;
  getSearchString: () => string;
} => {
  const router = useRouter();
  const search = router?.query || {};
  const getSearchString = (): string => {
    let searchString = '';
    if (router) searchString = `${router.asPath.split('?')[1] || ''}`;
    return searchString ? `?${searchString}` : searchString;
  };
  return { search, getSearchString };
};
